"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Aug 03 2018
 */

var DataObjectConverter_1 = require("../../../conversions/DataObjectConverter");
/**
 * {@code ResultWithOverview} converter.
 *
 * @author Radek Beran
 */


var ResultWithOverviewConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ResultWithOverviewConverter, _DataObjectConverter_);

  function ResultWithOverviewConverter() {
    _classCallCheck(this, ResultWithOverviewConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResultWithOverviewConverter).apply(this, arguments));
  }

  return ResultWithOverviewConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ResultWithOverviewConverter = ResultWithOverviewConverter;